export default "__VITE_ASSET__BsW8UNGR__"